import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../lib/cn';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      {...rest}
      className={cn(
        'block w-full rounded-md border-0 px-3 py-2 text-zinc-900 shadow-sm ring-1 ring-inset',
        'placeholder:text-zinc-400 focus:ring-2 focus:ring-inset',
        invalid
          ? 'ring-red-400 focus:ring-red-500'
          : 'ring-zinc-300 focus:ring-indigo-600',
        'disabled:cursor-not-allowed disabled:bg-zinc-50 disabled:text-zinc-500',
        className,
      )}
    />
  );
});
